"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ab = _interopRequireDefault(require("../../themes/ab"));

var _ant = _interopRequireDefault(require("../../themes/ant"));

var _bca = _interopRequireDefault(require("../../themes/bca"));

var _bcom = _interopRequireDefault(require("../../themes/bcom"));

var _harmony = _interopRequireDefault(require("../../themes/harmony"));

var _jb = _interopRequireDefault(require("../../themes/jb"));

var _pallet = _interopRequireDefault(require("../../themes/pallet"));

var _thdca = _interopRequireDefault(require("../../themes/thdca"));

var getTheme = function getTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bcom';
  var selectedTheme;

  switch (theme) {
    case 'ab':
      selectedTheme = _ab["default"];
      break;

    case 'ant':
      selectedTheme = _ant["default"];
      break;

    case 'bca':
      selectedTheme = _bca["default"];
      break;

    case 'bcom':
    default:
      selectedTheme = _bcom["default"];
      break;

    case 'jb':
      selectedTheme = _jb["default"];
      break;

    case 'harmony':
    case 'thd-dotcom':
    case 'thd':
      selectedTheme = _harmony["default"];
      break;

    case 'thdca':
      selectedTheme = _thdca["default"];
      break;

    case 'thd-instore':
    case 'pallet':
      selectedTheme = _pallet["default"];
      break;
  }

  return selectedTheme;
};

var _default = getTheme;
exports["default"] = _default;